module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    staticStyle: {
      "font-size": "smaller"
    },
    attrs: {
      "readlonly": "",
      "persistent-hint": "",
      "outline": "",
      "id": _vm.uuid,
      "label": _vm.label,
      "dark": _vm.dark,
      "value": _vm.textToCopy,
      "prepend-icon": _vm.prependIcon,
      "append-icon": "file_copy",
      "hint": _vm.copyLinkText
    },
    on: {
      "click:append": _vm.copyToClipboard
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-189bbac8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/CopyTextField.vue
// module id = 1342
// module chunks = 9